import { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@/primitives';
import { usePrivate } from '@/components/private';
import { white } from '@/lib/colours';

const SPLASH_SCREEN_DURATION = 2000;

const SplashScreen = () => {
  const { setShowSplashScreen } = usePrivate();
  const [isMounted, setMounted] = useState<boolean>(true);

  useEffect(() => {
    const timeout = setTimeout(() => setMounted(false), SPLASH_SCREEN_DURATION);

    return () => {
      clearTimeout(timeout);
      setShowSplashScreen && setShowSplashScreen(false);
    };
    //eslint-disable-next-line
  }, []);

  return (
    isMounted && (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '16px',
          backgroundColor: white[900],
          opacity: 1,
          pointerEvents: 'none', // Make the backdrop unclickable
          textAlign: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    )
  );
};

export default SplashScreen;
